module.exports = __webpack_public_path__ + "img/BOTON-SIGUIENTE.a8b066cc.svg";